import { EditCalendar } from "@mui/icons-material";
import { Box, Button, Fade, IconButton, Typography } from "@mui/material";
import { CalendarSelectionSummary } from "./CalendarSelectionSummary";
import { colors } from "../../ui/colors";

export default function CardSelectionCalendar({ showCard, setField, onConfirm, handleReset }) {
  return (
    <Fade in={showCard}>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography sx={{ fontWeight: 900, color: "var(--fx-surface-texttertiary, #94A3B8)", fontSize: 9 }}>CONFIRM PERIOD</Typography>
          <IconButton size="small" onClick={() => setField("showCard", false)} sx={{ color: colors.orange.base, bgcolor: colors.orange[50] }}>
            <EditCalendar fontSize="small" />
          </IconButton>
        </Box>
        <Box flex={1} display="flex" alignItems="center" justifyContent="center">
          <CalendarSelectionSummary />
        </Box>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            onConfirm();
            setField("showCard", false);
          }}
          sx={{
            bgcolor: colors.orange.base,
            textTransform: "none",
            fontWeight: 900,
            borderRadius: 3,
            py: 1.2,
            boxShadow: "none",
            mb: 1,
            "&:hover": { bgcolor: colors.orange[600], boxShadow: "none" },
          }}
        >
          Confirm Selection
        </Button>
        <Button fullWidth variant="text" onClick={handleReset} sx={{ color: "var(--fx-surface-texttertiary, #94A3B8)", textTransform: "none", fontWeight: 800, fontSize: 10 }}>
          Reset
        </Button>
      </Box>
    </Fade>
  );
}
